// accordionVisionData.js

const accordionVisionData = [
    {
      title: "What's Included",
      content: [
        "1000+ On-demand workouts",
        "Daily point earning and activity tracking",
        "Audio tracks and meditations",
        "Recipes and cook-along videos",
        "Personalized education programs",
        "Community and Leaderboard",
        "Registered Dietitian access",
      ],
    },
    {
      title: "Frequently Asked Questions",
      content: [
        {
          question: "What is included with Treo Wellness?",
          answer: [
            "1000+ On-demand workouts on and off equipment",
            "Daily activity tracking with custom habit tiles",
            "100+ audio tracks for better sleep",
            "Meditations for mental health",
            "Recipes and cook-along videos for healthy eating",
            "Personalized education programs specific to your health goal",
            "Community, daily points, and monthly leaderboard",
            "Access to Certified Wellness Coaching for accountability",
            "Access to Registered Dietitian for a free 60 min consultation",
          ],
        },
        {
          question: "Can I use Treo Wellness on my fitness equipment?",
          answer: [
            "Yes, we have on-demand workouts for treadmills, ellipticals, rowers, and more. Instructors cue to universal terms for resistance, speed, and incline.",
          ],
        },
        {
          question: "What if I need help?",
          answer: [
            "For any support needs, please email support@treowellness.com. We monitor the support inbox Monday – Friday 8AM CST – 5PM CST. Questions will be answered in the order they are received.",
          ],
        },
      ],
    },
  ];
  
  export default accordionVisionData;
  